// Generated by Melange

import * as Buhta_cabinet__DashboardContentTemplate from "../../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__HelpChatLayout from "./HelpChatLayout.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as JsxRuntime from "react/jsx-runtime";

function HelpChatPage(Props) {
  let id = Props.id;
  const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
        title: "Помощь"
      });
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
              header: header,
              children: JsxRuntime.jsx(Buhta_cabinet__HelpChatLayout.make, {
                    id: id,
                    onClose: (function (param) {
                        Buhta_cabinet__Route.navigateTo({
                              TAG: /* Admin */7,
                              _0: {
                                TAG: /* Help */3,
                                _0: /* Tickets */{
                                  _0: /* List */0
                                }
                              }
                            });
                      })
                  })
            });
}

const make = HelpChatPage;

export {
  make ,
}
/* Buhta_cabinet__DashboardContentTemplate Not a pure module */
